/* unplugin-vue-components disabled */import script from "./App.vue?vue&type=script&lang=ts&setup=true"
export * from "./App.vue?vue&type=script&lang=ts&setup=true"

import "./App.vue?vue&type=style&index=0&id=1255d85b&lang=scss"
import "./App.vue?vue&type=style&index=1&id=1255d85b&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/fm-tools/fm-tools/node_modules/.pnpm/vue-loader@16.8.3_webpack@5.65.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1255d85b"]])

export default __exports__